import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index';
import SettingsContent from '../Wrapper';
import AddTemplate from './EmailTemplates/AddTemplate';
import EditTemplate from './EmailTemplates/EditTemplate';
import BroadcastAgent from './broadcastAgent/BroadcastAgent.vue';
import AddAiBroadcast from './broadcastAgent/AddAiBroadcast.vue';
import FormList from './boostFormBuilder/FormList.vue';
import AddBoostForm from './boostFormBuilder/AddBoostForm.vue';
import ResponderList from './boostFormBuilder/ResponderList.vue';
import OutboundCallCampaign from './outboundCallCampaign/OutboundCallCampaign.vue';
import AddOutboundCallCampaign from './outboundCallCampaign/AddOutboundCallCampaign.vue';
import EditOutboundCallCampaign from './outboundCallCampaign/AddOutboundCallCampaign.vue';
import CampaignDetails from './outboundCallCampaign/CampaignDetails.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.ONE_OFF.HEADER',
        icon: 'sound-source',
      },
      children: [
        {
          path: 'one_off',
          name: 'one_off',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'add_campaign',
          name: 'add_campaign',
          roles: ['administrator'],
          component: { ...Index },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.EMAIL_TEMPLATES.HEADER',
        icon: 'sound-source',
        keepAlive: false,
      },
      children: [
        {
          path: 'email_templates',
          name: 'email_templates',
          roles: ['administrator'],
          component: { ...Index },
        },
        {
          path: 'email_templates/add',
          name: 'email_template_add',
          roles: ['administrator'],
          component: { ...AddTemplate },
        },
        {
          path: 'email_templates/edit/:templateId',
          name: 'email_template_edit',
          roles: ['administrator'],
          component: { ...EditTemplate },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns/aiBroadcast'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.HEADER_TITLE',
        icon: 'arrow-swap',
      },
      children: [
        // LLM chatbot
        {
          path: '',
          name: 'ai_broadcast_list',
          roles: ['administrator'],
          component: { ...BroadcastAgent },
        },
        {
          path: 'add',
          name: 'ai_broadcast_add',
          roles: ['administrator'],
          component: { ...AddAiBroadcast },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/campaigns/outbound-call-campaigns'
      ),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.HEADER_TITLE',
        icon: 'video-call',
      },
      children: [
        {
          path: '',
          name: 'outbound_call_campaigns',
          roles: ['administrator'],
          component: { ...OutboundCallCampaign },
        },
        {
          path: ':campaignId/details',
          name: 'outbound_call_campaign_details',
          roles: ['administrator'],
          component: { ...CampaignDetails },
          props: true,
        },
        {
          path: 'add',
          name: 'add_outbound_call_campaign',
          roles: ['administrator'],
          component: { ...AddOutboundCallCampaign },
        },
        {
          path: 'edit/:id',
          name: 'edit_outbound_call_campaign',
          roles: ['administrator'],
          component: { ...EditOutboundCallCampaign },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/campaigns/forms'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.CAMPAIGN_FORMS.HEADER_TITLE',
        icon: 'document',
      },
      children: [
        // LLM chatbot
        {
          path: '',
          name: 'campaign_form_list',
          roles: ['administrator'],
          component: { ...FormList },
        },
        {
          path: 'add',
          name: 'campaign_form_add',
          roles: ['administrator'],
          component: { ...AddBoostForm },
        },
        {
          path: ':campaign_form_id/edit',
          name: 'campaign_form_edit',
          roles: ['administrator'],
          component: { ...AddBoostForm },
        },
        {
          path: ':campaign_form_id/responders',
          name: 'campaign_form_responder_list',
          roles: ['administrator'],
          component: { ...ResponderList },
        },
      ],
    },
  ],
};
